import { Pagination } from "@mui/material";
import TablePagination from "@mui/material/TablePagination";
import * as React from "react";
interface ReactPaginationProps {
  page: number;
  rowsPerPage: number;
  count: number;
  onPageChange: (event: any, newPage: number) => void;
  onRowsPerPageChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
}
const ReactPagination: React.FC<ReactPaginationProps> = ({
  page,
  rowsPerPage,
  count,
  onPageChange,
  onRowsPerPageChange,
}) => {
  return (
    <TablePagination
      component="div"
      count={count}
      page={page}
      onPageChange={onPageChange}
      rowsPerPage={rowsPerPage}
      onRowsPerPageChange={onRowsPerPageChange}
      rowsPerPageOptions={[5, 10, 20, 30]}
      labelRowsPerPage="Itens por página:"
      labelDisplayedRows={({ from, to }) => ` ${from} - ${to} de ${count}`}
      ActionsComponent={() => {
        return (
          <Pagination
            count={Math.floor(count / rowsPerPage)}
            shape="rounded"
            page={page + 1}
            onChange={onPageChange}
            defaultPage={1}
          />
        );
      }}
      sx={{
        display: "flex",
        justifyContent: "end",
        backgroundColor: "white",
        "& .MuiTablePagination-spacer": {
          display: "none",
        },
        "& .MuiTablePagination-toolbar": {
          padding: "0px 15px 20px 0px",
          gap: "20px",
        },
        "& .MuiPaginationItem-root": {
          fontWeight: 700,
        },
        "& .MuiTablePagination-selectLabel": {
          color: "grey",
        },
        "& .MuiTablePagination-displayedRows": {
          color: "grey",
        },
      }}
    />
  );
};
export default ReactPagination;
